import commonConstants from "$/data/common";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React from "react";

function FaqSection({ color = "inherit" }) {
  const items = [
    {
      question: "Are my generated tattoos unique?",
      answer:
        "Yes, 100% unique! No tattoo will be the same design, even with the same prompt and style choice. What you get will be 100% unique and just for you. :)",
    },
    {
      question: "How much does BlackInk.AI cost?",
      answer: `BlackInk.AI is free to try. You can generate ${commonConstants.FREE_CREDITS} times for free. After that, you can subscribe to the Pro Unlimited Plan.`,
    },
    {
      question: "Do you support written text tattoos?",
      answer: "Currently, no. But we plan to in the future.",
    },
    {
      question: "Can I upload my own image?",
      answer: 'You can upload your own image through our "Image-to-Stencil" feature.',
    },
    {
      question: "What size are the image downloads?",
      answer: (
        <>
          4x High Res Image: 2048x2048px
          <br />
          Low Res Image: 512x512px
          <br />
          Printout Image: 512x512px
        </>
      ),
    },
    {
      question: "What languages do you support?",
      answer:
        "The AI tools support over 100 languages for user input. We translate the idea only if we detect non-English text, so we recommend English if possible. Content on the site is in English, so we recommend Google Translate while browsing.",
    },
    {
      question: "Are my custom design kept private?",
      answer:
        "When you create a design, you can specify if you want it private. Afterwards, you can toggle it being public in 'My Collection' >> click the 'Eye Ball' icon.",
    },
    {
      question: "Why do some tattoos come out weird?",
      answer:
        "Tattoos should be weird! It's a new and experimental product so there's always a chance of creating something strange.",
    },
    {
      question: "Should I get these tattoos as-is?",
      answer:
        "Sometimes there are weird shapes or bad symmetry. Always have your tattoo artist review and cleanup the design.",
    },
    {
      question:
        "What is the license for the generated tattoos? Am I allowed to get them tattooed?",
      answer: (
        <>
          The designs are intended to be used for personal use to get tattooed. You can
          read more about the license here:{" "}
          <a href="https://blackink.ai/legal/terms-of-service">Terms of Service</a>
        </>
      ),
    },
    {
      question: "Can I use designs for commercial purposes?",
      answer: (
        <>
          Tattoo artists are allowed to use designs for tattooing, but encouraged to be
          paying customers via a subscription. Resale and redistribution of work is not
          permitted (flash tattoo books, tattoo stickers, etc... contact us if
          interested in resale). You can read more about the license here:{" "}
          <a href="https://blackink.ai/legal/terms-of-service">Terms of Service</a>
        </>
      ),
    },
    {
      question: "How do I cancel my subscription?",
      answer:
        "Go to the menu and click on 'Settings' >> 'Billing'. You can cancel from the Stripe management dashboard.",
    },
    {
      question: "How do I delete my account?",
      answer:
        "Go to the menu and click on 'Settings' >> 'Account Info' >> Click the 'Account Deletion' button. You can delete your account there.",
    },
  ];

  return (
    <>
      {items.map((item, index) => (
        <Accordion
          sx={{
            boxShadow: "none",
            "&:before": {
              display: "none",
            },
            "&:not(:last-child)": {
              borderBottom: `1px solid #e0e0e0`,
            },
            "&.Mui-expanded": {
              margin: "0 !important",
            },
            backgroundColor: "transparent",
            color,
          }}
          key={index}
        >
          <AccordionSummary
            sx={{
              minHeight: 78,
              "& .MuiAccordionSummary-content": {
                margin: "0 !important",
              },
              backgroundColor: "transparent",
            }}
            expandIcon={<ExpandMore style={{ color }} />}
            aria-controls={`faq-panel-${index}`}
          >
            <Typography
              variant="h6"
              variantMapping={{
                h6: "h2",
              }}
              color={color}
            >
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails id={`faq-panel-${index}`}>
            <Typography color={color}>{item.answer}</Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
}

export default FaqSection;
